export const ApplicationOptionsDefaults = {
    loadBatchSize: 700,
    sleepBetweenBatches: 10,
    allowMultipleSelection: true,
    allowNoteSelectionStatePersistence: true,
};
